// Featured Blog Carousel - Custom Scrollbar
(function() {
  'use strict';
  
  function setupBlogScrollbar() {
    console.log('=== Setting up Featured Blog Scrollbar ===');
    
    // Find all featured blog sections
    const blogSections = document.querySelectorAll('.blog__posts');
    
    if (blogSections.length === 0) {
      console.log('No blog sections found');
      return;
    }
    
    console.log('Found', blogSections.length, 'blog section(s)');
    
    blogSections.forEach((blogList, sectionIndex) => {
      // Get all slides
      const slides = blogList.querySelectorAll('.blog__post, .slider__slide');
      const slideCount = slides.length;
      
      console.log(`Section ${sectionIndex}: ${slideCount} slides found`);
      
      if (slideCount <= 1) {
        console.log('Only 1 slide, skipping scrollbar');
        return;
      }
      
      // Find the slider-component wrapper
      const sliderComponent = blogList.closest('slider-component');
      if (!sliderComponent) {
        console.log('slider-component not found');
        return;
      }
      
      // Check if scrollbar already exists
      const existingScrollbar = sliderComponent.querySelector('.blog-scrollbar-track');
      if (existingScrollbar) {
        console.log('Scrollbar already exists, removing old one');
        existingScrollbar.remove();
      }
      
      // Create scrollbar elements
      const trackDiv = document.createElement('div');
      trackDiv.className = 'blog-scrollbar-track';
      
      const sliderDiv = document.createElement('div');
      sliderDiv.className = 'blog-scrollbar-slider';
      sliderDiv.style.width = (100 / slideCount) + '%';
      
      trackDiv.appendChild(sliderDiv);
      
      // Insert scrollbar after slider buttons
      const sliderButtons = sliderComponent.querySelector('.slider-buttons');
      if (sliderButtons) {
        sliderButtons.insertAdjacentElement('afterend', trackDiv);
      } else {
        sliderComponent.appendChild(trackDiv);
      }
      
      console.log('✓ Scrollbar created with width:', (100 / slideCount) + '%');
      
      // Function to update scrollbar position
      function updateScrollbarPosition() {
        let activeIndex = 0;
        
        // Find active slide by checking slider-counter--current
        const counterCurrent = sliderComponent.querySelector('.slider-counter--current');
        if (counterCurrent) {
          activeIndex = parseInt(counterCurrent.textContent) - 1;
        } else {
          // Fallback: check aria-hidden
          slides.forEach((slide, index) => {
            const ariaHidden = slide.getAttribute('aria-hidden');
            if (ariaHidden === 'false') {
              activeIndex = index;
            }
          });
        }
        
        // Calculate and set position
        const leftPosition = (activeIndex / slideCount) * 100;
        sliderDiv.style.left = leftPosition + '%';
        
        console.log('Position updated - Slide:', activeIndex + 1, 'Left:', leftPosition + '%');
      }
      
      // Initial position
      setTimeout(updateScrollbarPosition, 100);
      
      // Watch for counter changes
      const counterCurrent = sliderComponent.querySelector('.slider-counter--current');
      if (counterCurrent) {
        const observer = new MutationObserver(updateScrollbarPosition);
        observer.observe(counterCurrent, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
      
      // Also watch slide attribute changes
      slides.forEach(slide => {
        const observer = new MutationObserver(updateScrollbarPosition);
        observer.observe(slide, {
          attributes: true,
          attributeFilter: ['aria-hidden']
        });
      });
      
      // Listen for button clicks
      const prevButton = sliderComponent.querySelector('button[name="previous"]');
      const nextButton = sliderComponent.querySelector('button[name="next"]');
      
      if (prevButton) {
        prevButton.addEventListener('click', () => {
          setTimeout(updateScrollbarPosition, 50);
        });
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', () => {
          setTimeout(updateScrollbarPosition, 50);
        });
      }
      
      console.log('✓ Event listeners attached');
    });
    
    console.log('=== Setup Complete ===');
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupBlogScrollbar);
  } else {
    setupBlogScrollbar();
  }
  
  // Re-initialize in theme editor
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      setTimeout(setupBlogScrollbar, 300);
    });
  }
  
})();